import { styled } from 'common/styles'

export const Container = styled('div')`
  position: relative;
  background-color: var(--black);
`

export const ThumbImg = styled('img')`
  max-width: 100%;
  height: 100%;
  display: block;
  margin: 0 auto;
  object-fit: contain;
`
